import $ from 'jquery';
// import Instafeed from 'instafeed.js';
import DDTemplates from 'dd-templates';

import Drupal from './Drupal';
import Header from './Header';
import Footer from './Footer';
import FixNavigation from './FixNavigation';
import Menu from './Menu';
import MobileMenu from './MobileMenu';
import TermNavigation from './TermNavigation';
import Toolbar from './Toolbar';
import TopMenu from './TopMenu';
import Gallery from './Gallery';
import CalendarFeed from './CalendarFeed';
import MenuPods from './MenuPods';
import HeroSlider from './HeroSlider';
import Slider from './Slider';
import BackgroundImage from './BackgroundImage';
import Redirect from './Redirect';
import TruncateText from './TruncateText';
// import InstagramSlider from './InstagramSlider';
import Notifications from './Notifications';
import SearchCursor from './SearchCursor';
import CalendarGridFilters from './CalendarGridFilters';

// Add the theme behaviors

Drupal.behavior((context) => {
  // Helpers

  const $body = $(document.body, context);

  // DD Template Behaviors

  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Fix our damn menus from displaying orphaned children

  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.fixNavigation) {
      element.fixNavigation = new FixNavigation(element);
    }
  });

  // Main/Primary Site Navigation

  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.menu) {
      element.menu = new Menu(element);
      element.menuCtrl = new MobileMenu(element);
      element.menuPods = new MenuPods(element);
    }
  });
  $('#block-nice_menus-3 li.depth-1:last-child', context).each((i, element) => {
    if (!element.menu) {
      element.menuCtrl = new MobileMenu(element, {
        selector: 'a.depth-2',
      });
    }
  });

  // Remove top menu titles from left nav

  $('#nice-menu-3 li.depth-1:last-child li.depth-2', context).each((i, element) => {
    if (!element.topMenu) {
      element.topMenu = new TopMenu(element);
    }
  });

  // Controls the states of the menu and search states

  $('.site-toolbar', context).each((i, element) => {
    if (!element.toolbar) {
      element.toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display

  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Notifications

  $('.notifications', context).each((i, element) => {
    if (!element.notifications && $(element).find('.node').length) {
      element.notifications = new Notifications(element);
    }
  });

  // Fixed Header using Headroom.js

  $('.headroom', context).each((i, element) => {
    if (!element.headroom) {
      element.headroom = new Header(element);
    }
  });

  // Smart Footer

  $('.page-footer', context).each((i, footer) => {
    const $footprint = $('.footprint', context);
    if (!footer.smartFooter && $footprint.length) {
      footer.smartFooter = new Footer(footer, $footprint);
    }
  });

  // Term Navigation

  $('.term-nav', context).each((i, element) => {
    if (!element.termNavigation) {
      element.termNavigation = new TermNavigation(element);
    }
  });

  // Photo Galleries

  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.gallery) {
      element.gallery = new Gallery(element);
    }
  });

  // Calendar of Events View

  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element, {
        useFilters: true,
        filters: {
          All: 1000,
          Admissions: 1001,
          Advancement: 1009,
          Alumnae: 1004,
          Arts: 1005,
          Athletics: 1006,
          Counseling: 1010,
          Ministry: 1002,
          Parents: 1011,
          Schedule: 1007,
          Service: 1003,
          Social: 1008,
          Student: 1012,
          Video: 106,
        },
      });
    }
  });

  $('.view-grid-calendar', context).each((i, element) => {
    if (!element.calendarGridFilters) {
      element.calendarGridFilters = new CalendarGridFilters(element, {
        filters: {
          All: 1000,
          Admissions: 1001,
          Advancement: 1009,
          Alumnae: 1004,
          Arts: 1005,
          Athletics: 1006,
          Counseling: 1010,
          Ministry: 1002,
          Parents: 1011,
          Schedule: 1007,
          Service: 1003,
          Social: 1008,
          Student: 1012,
          Video: 106,
        },
      });
    }
  });

  // Hero Slider

  $('.hero, .banner', context).each((i, element) => {
    if (!element.heroSlider) {
      element.heroSlider = new HeroSlider(element);
    }
  });

  // Hero BG Images

  $('.banner .views-row', context).each((i, element) => {
    if (!element.backgroundImage) {
      element.backgroundImage = new BackgroundImage(element);
    }
  });

  // Pod Slider

  $('.home-pods, .home-recent-news', context).each((i, element) => {
    if (!element.slider) {
      element.slider = new Slider(element);
    }
  });

  // Pod Slider

  $('.dd-search-keywords', context).each((i, element) => {
    if (!element.searchCursor) {
      element.searchCursor = new SearchCursor(element);
    }
  });

  // Wraps outer container in hyperlink

  $('.hero .views-row, .home-pods', context).each((i, element) => {
    if (!element.redirect) {
      element.redirect = new Redirect(element);
    }
  });

  // Truncate post body text

  $('.home-events', context).each((i, element) => {
    if (!element.truncateText) {
      element.truncateText = new TruncateText(element, {
        wrapper: '.node-content',
        lines: 2,
        multi: true,
      });
    }
  });

  // Add Sitemap output using the digitaldcore.js function

  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }

  if ($('select[name="department"]').length > 0) {
    const options = $('select[name="department"] option');
    const arr = options.map((_, option) => ({ text: $(option).text(), value: option.value })).get();

    arr.sort((option1, option2) => {
      let $return = 0;
      if ((option2.value === 'All') || (option1.text > option2.text)) {
        $return = 1;
      } else if ((option1.value === 'All') || (option1.text < option2.text)) {
        $return = -1;
      }
      return $return;
    });

    options.each((i, option) => {
      option.value = arr[i].value;
      $(option).text(arr[i].text);
    });
  }
});



// WEBPACK FOOTER //
// ./theme.js